module.exports = new __parcel__URL__("empty.9c038745.png").toString();